export const isFunction = (val: unknown): val is (...args: unknown[]) => unknown => typeof val === "function";
export const isBoolean = (val: unknown): val is boolean => typeof val === "boolean";
export const isNumber = (val: unknown): val is number => typeof val === "number";
export const isString = (val: unknown): val is string => typeof val === "string";
export const isObject = (val: unknown): val is Record<string, unknown> => val !== null && typeof val === "object";
